import React, { useState, useEffect } from "react";
import Title from "../../Text/Title/Title";
import { SubTitle } from "../../Text/Subtitle/SubTitle.tsx";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap";
import { IStatus } from "../../../interfaces/IStatus.tsx";
import { FaPen, FaTrash } from 'react-icons/fa6';
import { FcOk } from "react-icons/fc";
import { VscError } from "react-icons/vsc";

import BigText from '../../Text/BigText/BigText';
import { FillingBottle } from 'react-cssfx-loading';
import { TableContainer, Paper, TableCell, TableRow, Table, TableHead, TableBody } from '@mui/material';

import useApiRequests from "../../../hooks/useApiRequests.tsx";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../hooks/useNotification";

function List() {
  //#region Hooks
  const { notify } = useNotification();
  const {
    createStatus,
    updateStatus,
    detailStatus,
    deleteStatus,
    getAllStatus,
  } = useApiRequests();
  //#endregion

  const [data, setData] = useState<IStatus[]>();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<string>('');

  //#region useEffects

  useEffect(() => {
    fetchData();
  }, []);

  //#endregion

  const fetchData = async () => {
    try {
      const data = await getAllStatus();
      if (data.success) {
        setData(data.data);
      } else {
        notify("Ocorreu um erro ao buscar os dados", { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleNewItem = () => {
    window.location.href = "/status/edit/new";
  };

  const handleEditItem = (id: string) => {
    window.location.href = `/status/edit/${id}`;
  };


  const handleDeleteItem = async () => {
    try{
      const data = await deleteStatus(itemToDelete);
      fetchData();
      setItemToDelete("");
      setDeleteModal(false);
    }catch(error){
      notify(error, {type: "error"});
    }
  }; 

  const handleGoBack = () => {
    const lastHref = localStorage.getItem("lastHref");
    window.location.href = lastHref || "";
  };

  return (
    <div className="page-container">
      <Row className="d-flex align-center justify-content-between w-100">
        <Col className="title-and-subtitle">
          <Title>Status</Title>
          <SubTitle>Listagem</SubTitle>
        </Col>

        <Col className="d-flex justify-content-end gap-2">
        <Button
              color="secondary"
              style={{ height: "44px" }}
              onClick={() => handleGoBack()}
            >
              Voltar
            </Button>


          <Button
            color="success"
            style={{ height: "44px" }}
            onClick={() => handleNewItem()}
          >
            Novo Status
          </Button>
        </Col>
      </Row>






      <div className="mt-5">
        {data == null ? (
          <div className="d-flex flex-column justify-content-center align-items-center gap-5 mt-5">
            <BigText type={1}>Carregando...</BigText>
            <FillingBottle width="100px" height="100px" color="#dddcdc" />
          </div>
        ) : (
          <>
            {data != null && (
              <>
                <TableContainer component={Paper} className="mb-5">
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow>
                        <TableCell className="th-text">Status</TableCell>
                        <TableCell className="th-text text-center">Posição Kanban/Menu</TableCell>
                        <TableCell className="th-text text-center">Notifica Parceiro</TableCell>
                        <TableCell className="th-text text-center">Etapa final</TableCell>

                        <TableCell />
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.length > 0 && data.map((item, index) => {
                          return (
                            <TableRow
                            
                            className="custom-table-style"
                              key={index}
                              sx={{ "& > *": { borderBottom: "unset" } }}
                              onDoubleClick={() =>
                                handleEditItem(item.id || "")
                              }
                            >
                              <TableCell className="theme-text-color">{item.name}</TableCell>
                              <TableCell className="text-center theme-text-color">{item.kanbanPosition}</TableCell>
                              <TableCell className="text-center theme-text-color">{item.sendToPartner.toString() == "true" ? <FcOk /> : <VscError color="red" />}</TableCell>
                              <TableCell className="text-center theme-text-color">{item.isFinishState.toString() == "true" ? <FcOk /> : <VscError color="red" />}</TableCell>
                              <TableCell align="right" width={20}>
                                <FaPen
                                  className="pointer"
                                  color="#0d6efd"
                                  data-tooltip-id="edit-dropdown"
                                  data-tooltip-content="Editar"
                                  data-tooltip-place="top"
                                  onClick={() => handleEditItem(item.id || "")}
                                />
                              </TableCell>
                              <TableCell align="right" width={20}>
                                <FaTrash
                                  className="pointer"
                                  color="#ff5e00"
                                  onClick={() => {
                                    setItemToDelete(item.id || "");
                                    setDeleteModal(!deleteModal);
                                  }}
                                  data-tooltip-id="delete-dropdown"
                                  data-tooltip-content="Deletar"
                                  data-tooltip-place="top"
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </>
        )}
      </div>
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
            <ModalHeader toggle={() => setDeleteModal(false)}>Deletar Status</ModalHeader>
            <ModalBody>
              Esta ação não poderá ser desfeita! Tem certeza que deseja deletar?
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={() => handleDeleteItem()}>
                Deletar
              </Button>{' '}
              <Button color="secondary" onClick={() => setDeleteModal(false)}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
    </div>
  );
}

export default List;
